export default "__VITE_ASSET__CZI5_Hcq__"